import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BellRing, Inbox, ChevronRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { API_URL, MetaProgress, mesLabel, comercialUrl } from './comercial360/com360Shared';
import { CAMPANHAS } from '../pages/MetasPage';

export const MinhaMetaCard = () => {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const show = ['comercial', 'chefe_equipa'].includes(user?.role);
  useEffect(() => {
    if (!show) return;
    axios.get(`${API_URL}/comerciais/me/meta`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [show]);
  if (!show || !d) return null;
  return (
    <Link to={comercialUrl(d.user_id)} data-testid="minha-meta-card"
      className="block rounded-2xl border border-slate-200 bg-white p-5 hover:border-[#4DD4E8] hover:shadow-sm transition-[border-color,box-shadow]">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-xs uppercase tracking-[0.18em] text-slate-500 flex-1">A minha meta · {mesLabel(d.mes)}</span>
        <ChevronRight className="w-4 h-4 text-slate-400" />
      </div>
      <MetaProgress meta={d.meta} feitos={d.feitos} testId="minha-meta-progress" />
      {[['semana', d.semana], ['mes', d.mes_campanhas]].map(([k, p]) => p && CAMPANHAS.some(([c]) => p.metas[c] > 0) && (
        <p key={k} className="mt-2 text-sm text-slate-700" data-testid={`minha-meta-${k}`}>
          <b>{k === 'semana' ? 'Esta semana' : 'Este mês'}:</b>{' '}
          {CAMPANHAS.map(([c, l]) => `${l} ${p.feitos[c]}/${p.metas[c] || 0}`).join(' · ')}
        </p>
      ))}
      <div className="mt-3 flex flex-wrap gap-4 text-sm">
        <span className={`inline-flex items-center gap-1 ${d.pend_atraso ? 'text-rose-600 font-semibold' : 'text-slate-600'}`} data-testid="minha-meta-pend">
          <BellRing className="w-4 h-4" />{d.pendencias} pendência(s){d.pend_atraso ? ` · ${d.pend_atraso} em atraso` : ''}
        </span>
        <span className={`inline-flex items-center gap-1 ${d.leads_paradas + d.leads_expiradas ? 'text-amber-700 font-semibold' : 'text-slate-600'}`} data-testid="minha-meta-leads">
          <Inbox className="w-4 h-4" />{d.leads_paradas} lead(s) parada(s) · {d.leads_expiradas} expirada(s)
        </span>
      </div>
    </Link>
  );
};
